import { history } from './history';

export const push = (redirectPath) => {
    history.push(redirectPath); // Changes browser URL instantly
    return { type: '@@router/DUMMY_PATCH' }; // Harmless token for Redux
};